import { useState } from 'react'

export const useHidden = visible => {
  const [show, setShow] = useState(visible)
  const setHidden = () => setShow(false)
  const setVisible = () => setShow(true)
  return { show, setHidden, setVisible }
}
